
/**
 *  @class
 *  @function Multicolumn
 */
if (!customElements.get('multicolumn')) {
    class Multicolumn extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.multicolumnItem = Array.from(this.querySelectorAll('.multicolumn__image_hover'));
        this.multicolumnItem.forEach((item, i) => {
            item.addEventListener('mouseover', () => {
                this.multicolumnItemHover(item, i);
            });
            item.addEventListener('mouseleave', () => {
                this.multicolumnItemLeave(item, i);
            });
        });
      }
      multicolumnItemHover(item, i){
        this.multicolumnItem.forEach((item, i) => {
            item.querySelector('.multicolumn_image_hover').style.display = 'none';
        });
        item.querySelector('.multicolumn_image_hover').style.display = 'block';
      }
      multicolumnItemLeave(item, i){
        this.multicolumnItem.forEach((item, i) => {
          item.querySelector('.multicolumn_image_hover').style.display = 'none';
         });
      }
    }
    customElements.define('section-multicolumn', Multicolumn);
}